import screens from "../assets/screens.png";
import { texts } from "../data/langs";
import "../App.css";

export const Works = () => {
  return (
    <div className="sec_work" id="Trabalhos">
      <section className="limiter switch-aspect">
        <div className="block">
          <img src={screens} className="img_screens" alt="logo" />
        </div>

        <div className="GAP-20 " />
        <div className="GAP-20 " />

        <div className="block switch-text-align">
          <div className="gradTxt">{texts[texts.active].works.div}</div>

          <div className="GAP-H20" />

          <h1>{texts[texts.active].works.h1}</h1>
          <h3>{texts[texts.active].works.h3}</h3>

          <div className="GAP-H20" />

          <div className="callToAct line">
            <a
              href="https://www.behance.net/morfosweb"
              target="_blank"
              className="btn1"
            >
              {texts[texts.active].works.btn1}
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};
